<template>
  <div class="login_bg">
    <div class="main d-flex align-items-center">
      <div class="mx-auto login-box">
        <form class="mx-auto" style="width: 80%;">
          <div class="login_title">
            <h2>教師登入</h2>
            <img class="close" src="../assets/images/btn_close.png" @click="closeLogin" alt="">
          </div>
          <input type="email" placeholder="請輸入帳號" class="form-control rounded" required autofocus v-model="account">
          <input type="password" placeholder="請輸入密碼" class="form-control my-4 rounded"  required v-model="password">
          <button class="btn btn-primary btn-block mt-5" >登入</button>
          <div class="forgotPw"> 忘記密碼?</div>
        </form>
      </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'Login',

  data () {
    return {
      account: '',
      password: ''
    }
  },
  methods: {
    closeLogin () {
      this.$emit('closeLogin', false)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .login_bg {
    width: 100%;
    height: 100%;
    background:rgba(0,0,0,0.9);
    position: fixed;
    z-index: 50;
    top: 0;
    left: 0;
    h2 {
      color: #ffffff;
      margin: 0;
    }
    img {
      cursor: pointer;
    }
  }
  .main {
    height: calc(100vh - 100px);
  }
  .login-box {
    width: 30%
  }
  .login_title {
    margin-bottom: 30px;
    .close {
      position: absolute;
      top: 90px;
      right: 20%;
      margin-left: 50px;
    }
  }
  .forgotPw {
    color: #ffffff;
    font-style: italic;
    text-decoration: underline;
    text-align: right;
    margin-top: 20px;
    cursor: pointer;
  }
  @media screen and (max-width: 500px){
    .login-box {
      width: 70%
    }
  }
</style>
